/** Turn a display-preferences object into the set of menu keys that are switched on. */
export function serializePreferencesToSelection<T extends Record<string, boolean | undefined>>(preferences: T) {
  const selection = new Set<string>();

  for (const [k, v] of Object.entries(preferences)) {
    if (v === true) {
      selection.add(k);
    }
  }

  return selection;
}
